<template>
  <article class="break-words rounded-md bg-white p-4">
    <div class="mb-3 flex items-center justify-between gap-2">
      <time class="text-xs text-slate-500">{{ formattedDate }}</time>
      <span
        v-if="isNew"
        class="rounded-sm bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800"
      >
        {{ t('new') }}
      </span>
    </div>
    <div class="space-y-2">
      <DashboardRosUpdateItem v-for="item in release.items" :key="item.id" :item="item" />
    </div>
  </article>
</template>

<script setup lang="ts">
import type { RosDashboardRelease } from '@/entities/ros-updates/ros-update.entity';
import { useFormattedDate } from '@/hooks/use-formatted-date';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { DateTime } from 'luxon';
import DashboardRosUpdateItem from './DashboardRosUpdateItem.vue';

const props = defineProps<{
  release: RosDashboardRelease;
  isNew?: boolean;
}>();

const { t } = useI18n();

const formattedDate = useFormattedDate(
  computed(() => props.release.releasedAt),
  DateTime.DATE_MED,
);
</script>

<i18n lang="json">
{
  "en": {
    "new": "New"
  },
  "de": {
    "new": "Neu"
  },
  "es": {
    "new": "Nuevo"
  }
}
</i18n>
